
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { initClient } from '../../api';
import { SurveyJsUiClient, SurveyView } from '../backend/backendapi';
import { unique } from '../../util';
import { QuestionHtmlModel, SurveyModel } from 'survey-core';

@Component
export default class AttachmentsButtonIfPresent extends Vue {
  @Prop({ required: true })
  surveyId!: string;

  private readonly surveyApi = initClient(SurveyJsUiClient);

  survey: SurveyView | null = null;

  get hasAttachments(): boolean {
    return this.extractAttachments().length > 0;
  }

  async mounted(): Promise<void> {
    this.survey = await this.surveyApi.getSurvey(this.surveyId);
  }

  extractAttachments(): string[] {
    const model = new SurveyModel(this.survey?.json ?? '{}');
    const questions = (model.pages ?? []).flatMap(page => page.questions ?? []);
    const uploadedFiles = questions
        .filter(q => q.fileupload)
        .map(q => q.fileupload as string);
    const links = questions
    .filter(e => e.getType() === 'html')
    .flatMap(q => {
      const htmlContent = (q as QuestionHtmlModel).html;
      if (!htmlContent || typeof htmlContent !== 'string') return [];

      // Safety check: If it's a massive PDF page/SVG layout wrapper, 
      if (htmlContent.length > 50000 && htmlContent.includes('<svg')) {
        return [];
      }

      // Strip out heavy <svg>...</svg> blocks before searching for hrefs
      const lightweightHtml = htmlContent.replace(/<svg[\s\S]*?<\/svg>/gi, '');

      // Extract links safely from the cleaned HTML string
      return [...lightweightHtml.matchAll(/href="([^"]*?)"/g)].map(e => e[1]);
    });

    return unique(uploadedFiles.concat(links));
  }

  openAttachments(): void {
    this.extractAttachments().forEach(url => window.open(url, '_blank'));
  }
}
